<div class="comments-container flex-column" style="position: relative;">
	@if (can_see_tabs) {
		<div class="flex-row" style=" margin-bottom: 0.5rem; gap: 1rem; padding-right: 3.5rem;">
		
			@if (active_comment_tab === 'public' && show_public_info) {
				<span style="color: #666; align-self: flex-start">{{'COMMENTS.IS_PUBLIC_INFO' | trans}}.</span>
			}
			
			
			<a 
				[class.active]="active_comment_tab === 'public'"
				(click)="active_comment_tab = 'public'"
				class="plain-link align-center flex-row"
				color="primary-light"
				style="color: #1e7df1; margin-left: auto;"
			><span>{{'COMMENTS.TAB.PUBLIC' | trans}}</span></a>

			<a
				[class.active]="active_comment_tab === 'internal'"
				(click)="active_comment_tab = 'internal'"
				class="plain-link align-center flex-row"
				color="primary-light"
				style="color: #1e7df1"
			>
				<span style="display: flex; align-items: center;">
					{{'COMMENTS.TAB.INTERNAL' | trans}}
				</span> &nbsp;
				<i icon="lock" style=" font-size: 0.75rem;"></i>
			</a>
		</div>
	}

	
	<div class="flex-row flex-static align-center" style="margin-top: 0.6rem; gap: 1rem; margin-bottom: 1rem;">
		<label class="textarea filled flex-dynamic" (keydown.enter)="add_comment($event)">
			<textarea placeholder="{{ 'COMMENT' | trans }}" [(ngModel)]="comment_text" (keyup)="show_public_info = true"></textarea>
		</label>
		<button class="filled round" color="secondary" (click)="add_comment($event)" style="margin-left: 0;">
			<i icon="send"></i>
		</button>
	</div>

	<div class="comments flex-column flex-dynamic">
		@if ('get_comments' | inProgress) {
			<knw-spinner color="primary" [size]="32" style="margin: 0 auto; display: block;"/>
		} @else {
			<div class="comment" *ngFor="let comment of comments; let i = index" [attr.title]="comment.created_date | datefmt">
				<span style="font-size: 0.9em; font-weight: 500; display: flex; align-items: center;">
					{{comment.created_date | datefmt : 'short_date_time' : false}}
					@if (comment.is_internal) {
						&nbsp;
						<i icon="lock" style="font-size: 0.75rem;  color: #1e7df1;"></i>
					}
				</span>
				<div class="comment-text">
					<strong style="font-weight: bold">
						{{comment.created_by_first_name}} {{comment.created_by_last_name}}:
					</strong>
					<p >{{comment.comment}}</p>
				</div>
			</div>
		}
	</div>
    <div #commentscontainer></div>

	
</div>
